import routes from '@/routes/routes';
import { ViteReactSSG } from 'vite-react-ssg';
import { initPreviewFromUrl } from '@/utils/preview';
// i18n
// i18n
import './i18n';
// Styles
import './styles/main.css';

if (typeof window !== 'undefined') {
  initPreviewFromUrl();
}

export const createRoot = ViteReactSSG({ routes });
